import * as React from "react"
import { Typeahead, AsyncTypeahead } from "react-bootstrap-typeahead"
import { Button, Form } from "react-bootstrap"
import { FaAngleDown } from "react-icons/fa"
import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany"
import { concat, of, Subject, Subscription } from "rxjs"
import { catchError, debounceTime, filter, map, switchMap } from "rxjs/operators"
import { DataLoader } from "../OrderRequests/GovCollection"
import GetAccountsByNameObservable from "../../api/Companies/GetAccountsByName"
import { RouteComponentProps, withRouter } from "react-router"
import { WorkforceClinicPortal } from "../../AppState"

interface CompanyInputState {
  companies: DataLoader<AutoFilterCompany>
}

interface CompanyInputProps {
  defaultValue?: string
  forceEdit?: boolean
  id?: string
  disabled?: boolean
  filter?: boolean
  skipInitialLoad?: boolean
  placeholder?: string
  emptyLabel?: string
  allowedCompanies?: AutoFilterCompany[]
  onChange?: (items: AutoFilterCompany[]) => void
}

class CompanyInput extends React.PureComponent<CompanyInputProps & RouteComponentProps, CompanyInputState> {
  companyAsyncTypeahead = React.createRef<AsyncTypeahead<AutoFilterCompany>>()
  companyTypeahead = React.createRef<Typeahead<AutoFilterCompany>>()
  companies$ = new Subject<string>()
  subscription?: Subscription
  state: CompanyInputState = { companies: {} }
  defaultCompanyName: string = this.props.defaultValue || this.getCompanyName()

  componentDidMount() {
    this.subscribeCompanies()
    if (!this.props.skipInitialLoad) this.onInputChange(this.defaultCompanyName)
  }

  componentDidUpdate(prevProps: CompanyInputProps & RouteComponentProps, prevState: CompanyInputState) {
    if (!this.defaultCompanyName && this.props.location.pathname !== prevProps.location.pathname) {
      this.companyAsyncTypeahead?.current?.clear()
      this.onInputChange("")
    }
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  onInputChange(value: string) {
    if (value === "") {
      this.setState({ companies: { selected: undefined } }, () => this.props.onChange && this.props.onChange([]))
    }
    else {
      this.companies$.next(value)
    }
  }

  getCompanyName() {
    const participation = sessionStorage.getItem("company-selection")
    const portals: WorkforceClinicPortal[] = JSON.parse(sessionStorage.getItem("wf2-STRY0045127-portals") || "{}")
    var company = undefined
    for (const p of portals) {
      for (const c of p.AssignedClientDetailsOfClinic) {
        if (c.ParticipationID.toString() == participation) {
          company = c
          break
        }
      }
      if (company) {
        break
      }
    }
    return company?.Name || ""
  }

  onChange = (companies: AutoFilterCompany[]) => {
    const selectedCompany = companies[0]
    this.setState({ companies: { ...this.state.companies, selected: selectedCompany } })
    this.props.onChange && this.props.onChange(companies)
  }

  subscribeCompanies() {
    this.subscription = this.companies$.pipe(
      debounceTime(500),
      filter(filter => filter.length >= 1 || filter.length === 0),
      switchMap((filter) => filter.length === 0 ?
        of({ loading: false, companies: this.state.companies.data }) :
        concat(
          of({ loading: true }),
          GetAccountsByNameObservable(filter).pipe(
            map((data) => ({ loading: false, companies: data })),
            catchError(() => of({ loading: false }))
          )
        )
      )
    ).subscribe(
      (state: { loading: boolean, companies?: AutoFilterCompany[] }) => {
        if (state.companies) {
          let filteredCompanies: AutoFilterCompany[] = state.companies || []
          if (this.props.allowedCompanies && Array.isArray(this.props.allowedCompanies)) {
            const allowedCompanies = this.props.allowedCompanies || []
            const merged = filteredCompanies.filter(c => allowedCompanies.find(item => item.AccountID === c.AccountID))
            filteredCompanies = merged
          }
          this.setState({ companies: { loading: state.loading, data: filteredCompanies, selected: this.defaultCompanyName ? filteredCompanies[0] : undefined } }, () => this.defaultCompanyName && this.onChange((state.companies || [])))
        } else {
          this.setState({ companies: { loading: state.loading } })

        }
      },
      () => this.setState({ companies: { loading: false } })
    )
  }

  render() {
    return (
      <>
        {(!this.defaultCompanyName || this.props.forceEdit) ? <AsyncTypeahead
          useCache={false}
          disabled={this.props.disabled}
          emptyLabel={this.props.emptyLabel || "No Companies Found"}
          filterBy={(option, props) => this.props.filter ? props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1 : true}
          id={this.props.id || "company"}
          isLoading={!!this.state.companies.loading}
          labelKey="Name"
          minLength={0}
          onInputChange={input => this.onInputChange(input)}
          onChange={items => this.onChange(items)}
          onSearch={() => { }}
          options={this.state.companies.data || []}
          placeholder={this.props.placeholder || "Enter the Company name"}
          ref={this.companyAsyncTypeahead}
          selected={this.state.companies.selected ? [this.state.companies.selected] : []}>
          {!this.state.companies.loading && !this.props.disabled &&
            <Button variant="toggle" onClick={() => { this.companyAsyncTypeahead?.current?.toggleMenu() }}>
              <FaAngleDown />
            </Button>}
        </AsyncTypeahead> : <Form.Control type="text" disabled defaultValue={this.state.companies.selected?.Name || ""} />}
      </>
    )
  }
}

export default withRouter(CompanyInput)
